export default "__VITE_ASSET__CHBEp6GC__"